var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M475.2 333.2c-12.4-6-27.4-.7-33.4 11.7-16.6 34.5-42.4 63.7-74.7 84.5C334 450.7 295.6 462 256 462c-113.6 0-206-92.4-206-206S142.4 50 256 50c39.6 0 78 11.3 111.2 32.5 32.3 20.7 58.1 50 74.7 84.5 6 12.4 20.9 17.7 33.4 11.7 12.4-6 17.7-20.9 11.7-33.4-20.6-42.9-52.6-79.2-92.8-104.9C353 14 305.2 0 256 0 187.6 0 123.3 26.6 75 75 26.6 123.3 0 187.6 0 256s26.6 132.7 75 181c48.4 48.4 112.6 75 181 75 49.2 0 97-14 138.2-40.5 40.1-25.8 72.2-62.1 92.8-104.9 5.9-12.5.7-27.4-11.8-33.4z",
    fill: "#f06548",
    opacity: 1,
    "data-original": "#f06548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.3 353.3c4.9 4.9 11.3 7.3 17.7 7.3s12.8-2.4 17.7-7.3l62.9-62.9c9.2-9.2 14.2-21.4 14.2-34.3s-5.1-25.2-14.2-34.3l-62.9-62.9c-9.8-9.8-25.6-9.8-35.4 0s-9.8 25.6 0 35.4l36.9 36.9H164.1c-13.8 0-25 11.2-25 25s11.2 25 25 25h142.2l-36.9 36.9c-9.8 9.6-9.8 25.4-.1 35.2z",
    fill: "#f06548",
    opacity: 1,
    "data-original": "#f06548"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.4dde945a2d9bcf862f5a2ef2b858c31e.svg";
export { ForwardRef as ReactComponent };